(() => {
  const moveScrollTrack = (root, direction) => {
    const track = root?.querySelector?.('[data-ck-scroll-track]');
    if (!track) return;

    const card = [...track.children].find((child) => child instanceof HTMLElement && !child.hidden);
    const styles = window.getComputedStyle(track);
    let gap = Number.parseFloat(styles.columnGap || styles.gap || '0');
    if (!Number.isFinite(gap)) gap = 0;

    const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
    track.scrollTo({
      left: Math.max(0, track.scrollLeft + direction * distance),
      behavior: 'smooth',
    });

    window.setTimeout(() => root.dispatchEvent(new CustomEvent('ck:scroll:update')), 360);
  };

  window.casekooScrollControl = (control, direction) => {
    const root = control?.closest?.('[data-ck-scroll]');
    if (!root) return;
    moveScrollTrack(root, direction);
  };

  if (document.documentElement.dataset.ckScrollExtraFallbackReady === 'true') return;
  document.documentElement.dataset.ckScrollExtraFallbackReady = 'true';

  document.addEventListener('click', (event) => {
    const control = event.target.closest?.('[data-ck-direct-scroll="true"]');
    if (!control || control.disabled) return;

    const direction = control.matches('[data-ck-scroll-previous]') ? -1 : 1;
    window.casekooScrollControl(control, direction);
  });
})();
